export default "__VITE_ASSET__9ea9c007__"